import React from "react";
import matchSorter from "match-sorter";
import Tooltip from "@material-ui/core/Tooltip/Tooltip";
import Button from "@material-ui/core/Button/Button";
import AddIcon from "@material-ui/core/SvgIcon/SvgIcon";
import Card from "../../../common/Card";
import ReactTable from "react-table";
import compose from "recompose/compose";
import {withStyles} from "@material-ui/core";
import connect from "react-redux/es/connect/connect";
import {getRaspaRecipes, newRaspaRecipe} from "../../../actions/raspaRecipeActions";
import MaterialTable from "material-table";
import {tableIcons} from "../../../utils/utils";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";

const styles = theme => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200,
    },
    dashboardCardSection: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1) * 8,
        width: '100%'
    },
    newRaspaRecipeTooltip: {
        position: 'fixed',
        top: '90vh',
        right: '2vh',
    },
    dense: {
        marginTop: 19,
    },
    menu: {
        width: 200,
    },
});

class RaspaRecipeCountUsageTable extends React.Component {
    constructor(props) {
        super(props);
    };

    componentDidMount() {
    }

    getColumns() {
        return [
            {
                title: 'Fabricante',
                id: 'fabricante',
                field: 'fabricante',
                filterMethod: (filter, rows) =>
                    matchSorter(rows, filter.value, {keys: ['fabricante']}),
                filterAll: true,
                minWidth: 200
            },
            {
                title: 'Modelo',
                id: 'modelo',
                field: 'modelo',
                filterMethod: (filter, rows) =>
                    matchSorter(rows, filter.value, {keys: ['modelo']}),
                filterAll: true,
                minWidth: 200
            },
            {
                title: 'Medida',
                id: 'medida',
                field: 'medida',
                filterMethod: (filter, rows) =>
                    matchSorter(rows, filter.value, {keys: ["medida"]}),
                filterAll: true,
                minWidth: 200
            },
            {
                title: 'Uso',
                id: 'total',
                field: 'Total',
                filterMethod: (filter, rows) =>
                    matchSorter(rows, filter.value, {keys: ["total"]}),
                filterAll: true,
                minWidth: 50
            },
            {
                title: 'LarguraBanda',
                field: 'larguraBanda',
                filterMethod: (filter, rows) =>
                    matchSorter(rows, filter.value, {keys: ["larguraBanda"]}),
                filterAll: true,
                minWidth: 100
            },
            {
                title: 'RaioRaspagem',
                field: 'raioRaspagem',
                filterMethod: (filter, rows) =>
                    matchSorter(rows, filter.value, {keys: ["raioRaspagem"]}),
                filterAll: true,
                minWidth: 80
            },
            {
                title: 'Perimetro',
                field: 'perimetro',
                filterMethod: (filter, rows) =>
                    matchSorter(rows, filter.value, {keys: ["perimetro"]}),
                filterAll: true,
                minWidth: 80
            },
            {
                title: 'AnguloOmbro',
                field: 'anguloOmbro',
                filterMethod: (filter, rows) =>
                    matchSorter(rows, filter.value, {keys: ["anguloOmbro"]}),
                filterAll: true,
                minWidth: 80
            },
            {
                title: 'ComprimentoOmbro',
                field: 'comprimentoOmbro',
                filterMethod: (filter, rows) =>
                    matchSorter(rows, filter.value, {keys: ["comprimentoOmbro"]}),
                filterAll: true,
                minWidth: 80
            },
            {
                title: 'RaioOmbro',
                field: 'raioOmbro',
                filterMethod: (filter, rows) =>
                    matchSorter(rows, filter.value, {keys: ["raioOmbro"]}),
                filterAll: true,
                minWidth: 80
            }

        ];
    }

    render() {
        const { classes, series } = this.props;
        return (
            <React.Fragment>

                    <Grid item xs={12} lg={12}  className={classes.dashboardCardSection}>
                        <Paper>
                    <MaterialTable
                        icons={tableIcons}
                        columns={this.getColumns()}
                        data={series}
                        title='Utilização das receitas'
                        options={{
                            filtering: true,
                            pageSize: 15,
                            pageSizeOptions: [10,25,50,100,200],
                        }}
                        // onRowClick={ (e, data) => {
                        //     console.log("row click", e);
                        //     console.log("row click data", data);
                        //     alert(e, false, data.os)
                        // }}
                    />


                        </Paper>
                    </Grid>


        </React.Fragment>
        )
    }
}

export default compose(
    withStyles(styles, {withTheme: true}),
)(RaspaRecipeCountUsageTable)
